import moment from 'moment'
import { DialogOptions } from '../../../models/modal.model'
import {
  GenericNotificationCode,
  NotificationOptions,
  parseGenericNotification,
} from '../../../models/notification.model'
import { Activity } from '../models/activity.entity'

export type ActivityNotificationCode =
  | GenericNotificationCode
  | 'ACTIVITY_DELETED'
  | 'ACTIVITY_RUNNING'
  | 'ACTIVITY_UPDATED'
  | 'CANNOT_EDIT_CRONJOB'

export type ActivityModalCode = 'ACTIVITY_DELETION'

/**
 * Parse goods return code to a notification
 * @param code - the goods return notification code
 * @returns the notification options
 */
export function parseActivityNotification(
  code?: ActivityNotificationCode,
): NotificationOptions {
  switch (code) {
    case 'ACTIVITY_DELETED':
      return {
        message: 'Activity deleted successfully',
        color: 'success',
      }
    case 'ACTIVITY_RUNNING':
      return {
        message: 'Activity is running',
        color: 'success',
      }
    case 'ACTIVITY_UPDATED':
      return {
        message: 'Activity updated successfully',
        color: 'success',
      }
    case 'CANNOT_EDIT_CRONJOB':
      return {
        message: 'Unable to edit cronjob. You need to create an activity first',
        color: 'error',
      }
    default:
      return parseGenericNotification(code)
  }
}

/**
 * Parse goods return code to an modal
 * @param code - the goods return modal code
 * @param activity - the goods return object
 * @returns the modal settings
 */
export function parseActivityModal(
  code: ActivityModalCode,
  activity?: Activity,
): DialogOptions {
  switch (code) {
    case 'ACTIVITY_DELETION': {
      const activityCode = activity?.code
      const activityStart = moment(
        activity?.lastExecution?.createdAt ?? activity?.createdAt,
      ).format('DD/MM/YYYY')
      const params: string[] = []
      if (activityCode) {
        params.push(activityCode)
      }
      if (activityStart) {
        params.push(activityStart)
      }
      return {
        title: 'Delete activity',
        message:
          'You are about to delete the activity <strong>%s</strong> of the <strong>%s</strong>. Proceed with deletion?',
        messageParams: params,
        buttons: ['Cancel', 'Confirm'],
      }
    }
    default:
      return {}
  }
}
